import { ICustomFormElement } from "./Abstract";
import { InputText } from "./Input";

class File extends InputText implements ICustomFormElement {
    initElements() {
        super.initElements();
        this.type = "file";
        return this;
    }

    /**
     * initialize attributes
     */
    initAttributes() {
        super.initAttributes();
        if (this.hasAttribute("multiple")) {
            this.multiple = this.getAttribute("multiple");
        }
        if (this.hasAttribute("accept")) {
            this.accept = this.getAttribute("accept");
        }
        return this;
    }

    attachEvents(): this {
        super.attachEvents();
        this.label.removeEventListener("click", this.clickHandler);
        this.addEventListener("dragover", this.dragAndDropHandler.bind(this));
        this.addEventListener("drop", this.dragAndDropHandler.bind(this));
        this.addEventListener("click", () => {
            this.input.click();
        });
        return this;
    }

    dragAndDropHandler(e: DragEvent) {
        e.preventDefault();
        this.label.classList.toggle("dragover", e.type === "dragover");

        if (e.type === "drop") {
            this.files = e.dataTransfer.files;
            this.dispatchEvent(new Event("change"));
        }
    }

    get multiple() {
        return this.input.getAttribute("multiple");
    }

    set multiple(v) {
        if (!v && this.input.hasAttribute("multiple")) {
            this.input.removeAttribute("multiple");
        } else {
            this.input.setAttribute("multiple", v);
        }
    }

    get accept() {
        return this.input.getAttribute("accept");
    }

    set accept(v) {
        if (!v && this.input.hasAttribute("accept")) {
            this.input.removeAttribute("accept");
        } else {
            this.input.setAttribute("accept", v);
        }
    }

    get files() {
        return (this.input as HTMLInputElement).files;
    }

    set files(v) {
        (this.input as HTMLInputElement).files = v;
    }
}

File.prototype.template.innerHTML = /*html*/ `
<label class="std-fe">
    <span class="label"><slot></slot></span>
    <span class="input"></span>
</label>
<span class="thumbs"></span>
<span class="error"></span>
<span class="help"></span>
`;

customElements.define("x-file", File);

export { File };
